<template>
    <div class="modal-overlay" v-if="visible">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button type="button" class="btn-close" @click="$emit('cancel')"></button>
          </div>
          <div class="modal-body">
            <div v-if="warning" class="alert alert-warning">
              <font-awesome-icon icon="exclamation-triangle" class="me-2" />
              {{ warning }}
            </div>
            <div class="form-group mt-3">
              <label class="form-label">Seleccionar Nuevo Estado</label>
              <select v-model="selected" class="form-select">
                <option v-for="estado in estados" :key="estado" :value="estado">
                  {{ estado }}
                </option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="$emit('cancel')">Cancelar</button>
            <button type="button" class="btn btn-success" :disabled="!selected" @click="$emit('confirm', selected)">
              Actualizar Estado
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
  export default {
    name: "ChangeStateModal",
    components: { FontAwesomeIcon },
    props: {
      visible: { type: Boolean, required: true },
      title: { type: String, required: true },
      estados: { type: Array, required: true },
      warning: { type: String, default: "" },
      value: { type: String, default: "" }
    },
    data() {
      return {
        selected: this.value
      };
    },
    watch: {
      value(newVal) {
        this.selected = newVal;
      }
    }
  };
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
  }
  .modal-dialog {
    background: #fff;
    border-radius: 8px;
    max-width: 500px;
    width: 90%;
    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  }
  .modal-content {
    border: none;
    border-radius: 8px;
  }
  .btn-close {
    background: transparent;
    border: none;
    font-size: 1.5rem;
  }
  </style>
  